module.exports = __webpack_public_path__ + "media/bootstrap-icons/skip-backward-btn-d08937a0.svg";